import { Keyboard } from "lucide-react";
import { useId, useRef, useState, type ChangeEvent, type ReactNode } from "react";
import { flushSync } from "react-dom";
import { operatorSecretInputAttributes } from "./operator-browser-policy";

/** A field becomes editable only through its own keyboard action. */
export function DowntimeKeyboardField({ label, keyboardLabel, value, onChange, disabled,
  multiline = false, secret = false, required = false, maxLength, minLength, placeholder,
}: {
  label: ReactNode;
  keyboardLabel: string;
  value: string;
  onChange: (value: string) => void;
  disabled: boolean;
  multiline?: boolean;
  secret?: boolean;
  required?: boolean;
  maxLength: number;
  minLength?: number;
  placeholder?: string;
}) {
  const id = useId();
  const [editable, setEditable] = useState(false);
  const field = useRef<HTMLInputElement | HTMLTextAreaElement | null>(null);
  const common = {
    id, value, disabled, required, maxLength, minLength, placeholder,
    readOnly: !editable,
    inputMode: editable ? secret ? "numeric" as const : "text" as const : "none" as const,
    autoComplete: "off",
    onBlur: () => setEditable(false),
    onChange: (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => onChange(event.target.value),
  };
  return <div className="downtime-keyboard-field">
    <label htmlFor={id}>{label}</label>
    <div className="downtime-text-control">
      {multiline
        ? <textarea {...common} ref={(node) => { field.current = node; }} rows={2} />
        : <input {...common} {...(secret ? operatorSecretInputAttributes : {})}
            ref={(node) => { field.current = node; }} type={secret ? "password" : "text"}
            pattern={secret ? "[0-9]{4}" : undefined} />}
      <button type="button" aria-label={keyboardLabel} disabled={disabled} onClick={() => {
        flushSync(() => setEditable(true));
        field.current?.focus();
      }}><Keyboard size={18} aria-hidden="true" /></button>
    </div>
  </div>;
}
